'use client';

import { useState, useEffect } from "react";
import { Layout, Row, Col, Typography, Button, Space } from "antd";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";

const { Footer } = Layout;
const { Title, Text } = Typography;

const AppFooter = () => {
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  const links = [
    {
      title: "Popular Cuisines",
      links: [
        { label: "American food near me", url: "" },
        { label: "Asian food near me", url: "" },
        { label: "Chinese food near me", url: "" }
      ]
    },
    {
      title: "Popular Dishes",
      links: [
        { label: "Accessibility", url: "/accessibility" },
        { label: "Cookies", url: "/cookies" },
        {
          label: "Cookie Preferences",
          url: "/cookie-preferences",
          onClick: () => setShowCookieBanner((v) => !v)
        },
        { label: "Data Privacy (DSAR)", url: "/dsar" }
      ]
    },
    {
      title: "Restaurant Types",
      links: [
        { label: "Privacy Policy", url: "/privacy-policy" },
        { label: "Terms of Use (Users)", url: "/terms-of-use/users" },
        { label: "Terms of Use (Merchants)", url: "/terms-of-use/merchants" },
        { label: "EULA", url: "/eula" },
        { label: "Merchant Agreement", url: "/merchant-agreement" }
      ]
    },
    {
      title: "Locations",
      links: [
        { label: "Accessibility", url: "/accessibility" },
        { label: "Cookies", url: "/cookies" },
        {
          label: "Cookie Preferences",
          url: "/cookie-preferences",
          onClick: () => setShowCookieBanner((v) => !v)
        },
        { label: "Data Privacy (DSAR)", url: "/dsar" }
      ]
    }
  ];

  const handleClick = (link: string) => {
    // If you're using react-router-dom:
    // navigate(link);
    console.log("Navigate to:", link);
  };

  useEffect(() => {
    // Load Facebook SDK
    const fbScript = document.createElement("script");
    fbScript.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v19.0";
    fbScript.async = true;
    fbScript.crossOrigin = "anonymous";
    document.body.appendChild(fbScript);

    // Load LinkedIn SDK
    const linkedInScript = document.createElement("script");
    linkedInScript.src = "https://platform.linkedin.com/in.js";
    linkedInScript.type = "text/javascript";
    linkedInScript.innerHTML = "lang: en_US";
    document.body.appendChild(linkedInScript);

    fbScript.onload = () => (window as any).FB?.XFBML.parse();
    linkedInScript.onload = () => (window as any).IN?.parse();
  }, []);

  return (
    <Footer style={{ background: "#000", color: "#fff", padding: "60px 30px" }}>
      <div className="container">
        <Row gutter={[16, 16]}>
          {/* Logo Row */}
          <Col span={24}>
            <img
              src="/logo.svg"
              width={120}
              height={60}
              alt="Logo"
              style={{ height: 32 }}
            />
          </Col>

          {/* Dynamic Link Groups */}
          {links.map((group) => (
            <Col flex="1 1 200px" key={group.title}>
              <Title
                level={4}
                style={{ color: "#fff", marginBottom: 24, fontSize: 18 }}
              >
                {group.title}
              </Title>
              <Space direction="vertical" style={{ width: "100%" }}>
                {group.links.map((link) => {
                  if (link.url.includes("https")) {
                    return (
                      <a
                        key={link.url}
                        href={link.url}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: "#ccc" }}
                      >
                        {link.label}
                      </a>
                    );
                  }
                  if (link.onClick) {
                    return (
                      <Button
                        key={link.label}
                        type="link"
                        style={{ padding: 0, color: "#ccc" }}
                        onClick={link.onClick}
                      >
                        {link.label}
                      </Button>
                    );
                  }
                  return (
                    <div
                      key={link.url}
                      style={{ color: "#ccc", cursor: "pointer" }}
                      onClick={() => handleClick(link.url)}
                    >
                      {link.label}
                    </div>
                  );
                })}
              </Space>
            </Col>
          ))}

          {/* Contact Column */}
          <Col flex="1 1 200px">
            <Title
              level={4}
              style={{ color: "#fff", marginBottom: 24, fontSize: 18 }}
            >
              Contact
            </Title>
            <Space direction="vertical" style={{ width: "100%" }}>
              <img alt="playstore" src="/Home/playstore.svg"/>
              <img alt="appstore" src="/Home/appStore.svg"/>
              
              <Title
              level={4}
              style={{ color: "#fff", marginTop: 24, fontSize: 18 }}
            >
              Follow Us On
            </Title>

            <div style={{gap:15, display:"flex"}}>
            <img alt="twit" src="/Home/linkedin.svg"/>
            <img alt="link" src="/Home/fb.svg"/>
            <img alt="fb" src="/Home/twitter.svg"/>
            </div>
              
            </Space>
          </Col>
        </Row>
      </div>
    </Footer>
  );
};

export default AppFooter;
